import { apiServer } from 'settings/web-services/api';

export function markNotificationAsRead(cfg) {
  return apiServer.post('/notifications/read', cfg);
}

export function getInitalNotifications({ cursor, limit, dateFilter, pinned }) {
  const params = new URLSearchParams();

  if (limit) params.append('limit', limit);
  if (pinned) params.append('pinned', 'true');
  if (cursor) params.append('cursor', cursor);
  if (dateFilter) params.append('dateFilter', dateFilter);

  return apiServer.get(`/notifications/all?${params.toString()}`);
}
